import React from 'react';
import type { Block } from '../../../types/parcours';

interface StatItem {
  value: string;
  label: string;
  /** Description longue de la stat. Alias acceptés : `note`, `description` */
  note?: string;
  description?: string;
}

interface StatsGridBlock extends Block {
  type: 'stats-grid' | 'stats' | 'stats_grid';
  items?: StatItem[];
}

interface Props {
  block: StatsGridBlock;
}

export default function StatsGridBlock({ block }: Props) {
  if (!block.items?.length) return null;

  return (
    <div className="my-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {block.items.map((item, idx) => {
        // Accepte `note` ou `description` indifféremment
        const subtitle = item.note ?? item.description;
        return (
          <div
            key={idx}
            className="flex flex-col items-center justify-center rounded-xl border border-neutral-100 bg-white p-5 shadow-sm text-center"
          >
            <span className="text-3xl font-bold bg-gradient-to-r from-[#d03484] to-[#d47254] bg-clip-text text-transparent leading-none mb-1">
              {item.value}
            </span>
            <span className="text-sm font-medium text-neutral-700 mt-1">{item.label}</span>
            {subtitle && (
              <span className="text-xs text-neutral-400 mt-0.5">{subtitle}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
